import React from "react";
import PageWrapper from "../Components/Other/PageWrapper";
import { useEffect, useState } from "react";
import PageBanner from "../Components/Other/PageBanner";
import { CommonApiFun } from "../Redux/Action/index";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ToastMgs from "../Components/Other/ToastMgs";

function ContactUs(props) {
  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    mobile: "",
    message: "",
    Subscribe: false,
    email: "",
    error: false,
  });
  const [isloading, setIsloading] = useState(false);
  const dispatch = useDispatch();
  const clinicInfo = useSelector((state) => state.clinicInfo);
  const onlineConsultation = useSelector((state) => state.onlineConsultation);
  console.log('state', state)

  useEffect(() => {
    var data = { action: "clinic" };
    dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data)))
      .then((res) => {
        if (res.status == "success") {
          dispatch({ type: "CLINIC_INFO", payload: res.data });
          dispatch({
            type: "CONSULTATION_INFO",
            payload: res.online_consultation,
          });
        } else {
          // toast(<ToastMgs status={"Cancelled"} message={"Something went wrong please try again ...."} />)
        }
      })
      .catch((e) => {
        //toast(<ToastMgs status={"Cancelled"} message={"Something went wrong please try again ...."} />)
      });
  }, []);

  const handleChnage = (e, name) => {
    setState((prev) => ({ ...prev, [name]: e.target.value, error: false }));
  };

  const onHandleTelephoneChange = (e, name) => {
    let telephone = e.target.value;
    if (telephone === "" || /^[0-9+\-() .]*$/.test(telephone)) {
      setState((prev) => ({ ...prev, [name]: e.target.value, error: false }));
    }
  };

function ValidateMobile(number) {
    number = number.trim();
    var validFormat = /^\+?(\d[\d-. ]+)?(\([\d-. ]+\))?[\d-. ]+\d$/;
    if (!validFormat.test(number)) {
        return false;
    }
    var digitCount = number.replace(/\D/g, '').length;
    if (digitCount >= 7 && digitCount <= 15) {
        return true;
    } else {
        return false;
    }
}

  const handleSubmit = (e) => {
    e.preventDefault();
    const { first_name, last_name, email, mobile, message, Subscribe } = state;
    if (first_name == "" || last_name == "" || email == "" || mobile == "") {
      setState((prev) => ({ ...prev, error: true }));
      //alert("empty fild")
    } else if (
      !email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      setState((prev) => ({ ...prev, error: true }));
      // alert("email validation")
    } else if (!ValidateMobile(mobile)) {
      setState((prev) => ({ ...prev, error: true }));
    } else {
      setIsloading(true);
      var data = {
        first_name,
        last_name,
        email,
        mobile,
        message,
        subscribe: Subscribe,
        action: "contact_us",
      };
      dispatch(CommonApiFun("api/contact_us/post", JSON.stringify(data)))
        .then((res) => {
          toast(
            <ToastMgs
              status={res.success ? "success" : "Cancelled"}
              message={res.message}
            />
          );
          // if(res.success){
          setIsloading(false);
          // }else{

          // }
          setState((prev) => ({
            ...prev,
            first_name: "",
            last_name: "",
            mobile: "",
            message: "",
            Subscribe: false,
            email: "",
            error: false,
          }));
        })
        .catch((e) => {});
    }
  };
  return (
    <PageWrapper className={"contactus-page"}>
      <div className="pageWrapper">
        <PageBanner pageName={"Contact Us"}></PageBanner>
        <div className="MainContent">
          <div className="container">
            <div className="row contactForm">
              <div className="col-xs-12 col-md-8 col-9">
                <form className="custom-form">
                  <h3>Healthy outside starts from the inside first.</h3>
                  <div>
                    <div className="form--section cols-2 layout-even">
                      <div className="form--group">
                        <label htmlFor="first-name" className="form--label">
                          First name<span className="required">*</span>
                        </label>
                        <div className="input input--with-icon icon-right">
                          <input
                            placeholder="Your first name"
                            className="input-input"
                            id="first-name"
                            type="text"
                            name="first-name"
                            onChange={(e) => handleChnage(e, "first_name")}
                            value={state.first_name}
                            style={{
                              borderColor:
                                state.error && state.first_name == ""
                                  ? "red"
                                  : "",
                            }}
                          />
                        </div>
                      </div>
                      <div className="form--group">
                        <label htmlFor="last-name" className="form--label">
                          Surname<span className="required">*</span>
                        </label>
                        <div className="input input--with-icon icon-right">
                          <input
                            placeholder="Your surname"
                            className="input-input"
                            id="last-name"
                            type="text"
                            name="last-name[last-name]"
                            value={state.last_name}
                            onChange={(e) => handleChnage(e, "last_name")}
                            style={{
                              borderColor:
                                state.error && state.last_name == ""
                                  ? "red"
                                  : "",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form--section cols-2 layout-even">
                      <div className="form--group">
                        <label htmlFor="phone" className="form--label">
                          Phone*
                        </label>
                        <div className="input input--with-icon icon-right">
                          <input
                            placeholder="Your phone number"
                            className="input-input"
                            id="phone"
                            type="text"
                            name="phone"
                            value={state.mobile}
                            onChange={(e) =>
                              onHandleTelephoneChange(e, "mobile")
                            }
                            style={{
                              borderColor:
                                state.error &&
                                (state.mobile === "" ||
                                  !ValidateMobile(state.mobile))
                                  ? "red"
                                  : "",
                            }}
                          />
                        </div>
                      </div>
                      <div className="form--group">
                        <label htmlFor="email-id" className="form--label">
                          E-mail<span className="required">*</span>
                        </label>
                        <div className="input input--with-icon icon-right">
                          <input
                            placeholder="Your e-mail address"
                            className="input-input"
                            id="email-id"
                            type="text"
                            name="email-id"
                            value={state.email}
                            onChange={(e) => handleChnage(e, "email")}
                            style={{
                              borderColor:
                                (state.error && state.email == "") ||
                                (state.error &&
                                  !state.email.match(
                                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                  ))
                                  ? "red"
                                  : "",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form--section col-full layout-even">
                      <div className="form--group">
                        <label htmlFor="text-message" className="form--label">
                          Your message to us
                        </label>
                        <div className="custom-textarea">
                          <textarea
                            placeholder="How can we help you?"
                            className="textarea-input"
                            id="text-message"
                            name="text-message"
                            // defaultValue={state.message}
                            value={state.message}
                            onChange={(e) => handleChnage(e, "message")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form--section col-full layout-even">
                      <div className="form--group">
                        <div className="custom-checkbox">
                          <input
                            className="checkbox-input"
                            id="checkbox-newsletter"
                            type="checkbox"
                            name="checkbox-newsletter"
                            defaultValue={1}
                            defaultChecked={state.Subscribe}
                            onClick={() => {
                              setState((prev) => ({
                                ...prev,
                                Subscribe: !state.Subscribe,
                              }));
                            }}
                          />
                          <label
                            htmlFor="checkbox-newsletter"
                            className="form--label-checkbox"
                          >
                            I would like to receive information via the
                            newsletter.
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="actions">
                    <button
                      className={`btn btn-uppercase next_button btn-relative ${
                        isloading ? "btn--loading" : ""
                      }`}
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                    >
                      <span className="btn-text"> Submit form</span>
                      <span className="btn__loader">
                        <div
                          role="progressbar"
                          aria-valuemin={0}
                          aria-valuemax={100}
                          className="progress-circular progress-circular--visible progress-circular--indet"
                          style={{ height: 23, width: 23 }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
                            style={{ transform: "rotate(0deg)" }}
                          >
                            <circle
                              fill="transparent"
                              cx="43.80952380952381"
                              cy="43.80952380952381"
                              r={20}
                              strokeWidth="3.8095238095238093"
                              strokeDasharray="125.664"
                              strokeDashoffset="125.66370614359172px"
                              className="progress-circular__overlay"
                            />
                          </svg>
                        </div>
                      </span>
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-xs-12 col-md-4 col-3 contact_text">
                <div className="contact_text_inner">
                  <h3>Let's get connected</h3>
                  <ul className="listUnstyle">
                    {clinicInfo.map((item, index) => {
                      return (
                        <li key={index}>
                          <h4>
                            {item.title.charAt(0).toUpperCase() +
                              item.title.slice(1)}
                          </h4>
                          <span>{item.address}</span>
                          <span>
                            <a href={"tel:" + item.mobile}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 32 32"
                              >
                                <path d="M23.45 20.93a3 3 0 0 0-4.25 0l-1.45 1.45a26.14 26.14 0 0 1-4.51-3.62 26.62 26.62 0 0 1-3.62-4.51l1.45-1.45a3 3 0 0 0 0-4.25L8.24 5.73a2.93 2.93 0 0 0-2.11-.88A3 3 0 0 0 4 5.73L2.64 7.08A6.37 6.37 0 0 0 1 12.33c.32 3.75 2.78 8.26 6.57 12.06s8.35 6.25 12.1 6.61a7.87 7.87 0 0 0 .84 0 6.07 6.07 0 0 0 4.41-1.64L26.27 28a3 3 0 0 0 .88-2.13 2.93 2.93 0 0 0-.88-2.11zm1.41 5.66l-1.36 1.35a4.57 4.57 0 0 1-3.66 1c-3.25-.28-7.39-2.58-10.81-6S3.31 15.41 3 12.16A4.53 4.53 0 0 1 4 8.5l1.41-1.36a1 1 0 0 1 .71-.29 1 1 0 0 1 .71.29L9.66 10a1 1 0 0 1 0 1.41l-2 2a1 1 0 0 0-.16 1.21 27.49 27.49 0 0 0 4.33 5.58 27.49 27.49 0 0 0 5.58 4.33 1 1 0 0 0 1.21-.16l2-2a1 1 0 0 1 1.41 0l2.83 2.83a1 1 0 0 1 .29.71 1 1 0 0 1-.29.68zm1.74-21.2A14.92 14.92 0 0 0 16 1a1 1 0 1 0 0 2 13 13 0 0 1 13 13.11 1 1 0 1 0 2 0 14.91 14.91 0 0 0-4.4-10.72zm-5.69 5.72a6 6 0 0 1 1.77 4.31 1 1 0 1 0 2 0 8 8 0 0 0-8-8.1 1 1 0 1 0 0 2 6 6 0 0 1 4.23 1.79z"></path>
                              </svg>
                              <span>{item.mobile}</span>
                            </a>
                          </span>
                          <span>
                            <a href={item.location_link} target={"_blank"}>
                              {" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                className=""
                              >
                                <path d="m12 22.72a.74.74 0 0 1 -.53-.22l-5.76-5.76a8.9 8.9 0 1 1 12.58 0l-5.76 5.76a.74.74 0 0 1 -.53.22zm0-19.67a7.4 7.4 0 0 0 -5.23 12.63l5.23 5.23 5.23-5.23a7.4 7.4 0 0 0 -5.23-12.63z"></path>
                                <path d="m12 13.75a3.75 3.75 0 1 1 3.75-3.75 3.75 3.75 0 0 1 -3.75 3.75zm0-6a2.25 2.25 0 1 0 2.25 2.25 2.25 2.25 0 0 0 -2.25-2.25z"></path>
                              </svg>
                              <span>In Google Maps</span>
                            </a>
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="listUnstyle">
                    <h4>Online Consultation</h4>

                    <li>
                      <span>
                        {onlineConsultation.map((data) => {
                          return (
                            <span key={data}>
                              {data}
                              <br />
                            </span>
                          );
                        })}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default ContactUs;
